import { BALANCE_CURRENCY_UPDATED, GAMES_JACKPOTS_LIST } from '@gig/magic-messages';
import { magic } from '@gig/magic-sdk';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class JackpotsService {
  constructor() {
    this.jackpots = {};
    this.subscribeToCurrencyChanges();
  }
  subscribeToCurrencyChanges() {
    window.eventBus.subscribe(BALANCE_CURRENCY_UPDATED, (event) => __async(this, null, function* () {
      const currency = event.payload;
      this.jackpots = yield magic.methods.games.jackpots(currency);
      window.eventBus.publish(GAMES_JACKPOTS_LIST, this.jackpots);
    }), { replay: true, distinct: true });
  }
}

export { JackpotsService };
